import { Layout, ConfigProvider, Row, Input, Col, Pagination } from 'antd';
import Icon, { CalendarOutlined, CheckCircleOutlined, SearchOutlined, TeamOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from "react";
import css from './colleges.module.less';
import PageFooter from "../common/page-footer/footer";
import zhCN from 'antd/lib/locale/zh_CN';
import {sendHttpPostRequest} from "../../api/http-request";
import { BACKEND_API_URL } from '@/constants/constants';
import { ReactComponent as checkSvg } from '../static/image/check.svg'
const checkIcon = (props:any) => (<Icon component={checkSvg} {...props} />)

const cases = [
    {
        collegeName:"北京科技大学",
        collegeLogo:"static/college_logos/2022-04-13/北京科技大学-01.svg",
        schoolName:"理学院",
        studentNum:"100+",
        years:4,
        usedTags:["机器学习","深度学习","计算机视觉"],
        outcome:['为达成统计学专业对学生“掌握大数据分析、人工智能、数据可视化方面的常用方法和手段”的培养要求，在第四学年开设的《统计计算与软件》课程，采用博雅数智的“数据实验楼”平台进行实践性教学。平台包括数据分析、数据可视化、机器学习、深度学习和人工智能相关的多个综合实训项目。','综合课程本身的特点和个性化培养需求，选取了“COVID-19疫情可视化分析与建模项目”、“个人信用风险评估”、“电商数据分析”、“交通道路语义分割”、“微博数据舆情分析”、“车牌智能检测与识别”和“视频智能检索”等项目用于实训教学。'],
        usetProjects:["COVID-19疫情可视化分析与建模项目","电商数据分析项目","脑肿瘤智能诊断项目","微博数据舆情分析项目","个人信用风险评估","交通道路语义分割"],
        reviews:'"数据实验楼平台为我们的实践教学提供了强有力的支持，真实的项目场景和数据帮助学生快速适应 实际工作环境，大大提升了他们的就业竞争力。" —— 北京科技大学 徐老师'
    },
    {
        collegeName:"南方科技大学",
        collegeLogo:"static/college_logos/2024-09-20/南方科技大学-01.svg",
        schoolName:"数学系",
        studentNum:"600+",
        years:4,
        usedTags:["机器学习","自然语言处理"],
        outcome:['在《数据科学概论》课程的开设过程中，引入爱数课平台(idatacourse)和数据实验楼平台(idatacoding)，采用理论与实践相结合的教学方式锻炼学生的综合能力。','选取了爱数课平台“数据科学导论”、“深度学习”、“python数据分析”和“数据可视化”4门课程的全套资源支持《数据科学概论》课程建设；还选取了数据实验楼平台“个人信用风险评估项目”和“微博数据舆情分析项目”，用完整的项目锻炼学生在数据清洗、数据可视化、特征工程方面的实际应用能力和数据分析报告的撰写能力。'],
        usetProjects:["个人信用风险评估项目","微博数据舆情分析项目"],
        reviews:'"数据实验楼项目作为爱数课理论课堂的拓展与延伸，能够有效提升学生的实践操作水平，使学生掌握学以致用的方法，真切体会到知识如何在实际场景中得以运用。" —— 南方科技大学数学系 张教授'
    },
    {
        collegeName:"山西大学",
        collegeLogo:"static/college_logos/2022-02-16/山西大学-01.svg",
        schoolName:"大数据科学与产业研究院",
        studentNum:"300+",
        years:3,
        usedTags:["计算机视觉","深度学习","人工智能"],
        outcome:['研究院致力于人工智能与大数据相关的科学研究、人才培养和技术创新，以计算机科学与技术、统计学为支撑学科，融通其它学科进行深度交叉研究。','为契合研究院的建设目标与发展规划，选取数据实验楼的“交通道路语义分割项目”、“微博数据舆情分析项目”和“植物健康枯萎图像识别项目”3个项目作为实践抓手。'],
        usetProjects:["交通道路语义分割项目","微博数据舆情分析项目","植物健康枯萎图像识别项目"],
        reviews:'"在人才培养环节，数据实验楼为学生构建起贴合实际的数据实践空间，以多元项目任务为依托，从海量数据处理到智能模型构建全方位演练，迅速提升实操水平，同时也为教师在人工智能与大数据方向提供了教学思路，促进教学相长与专业人才培育。"  —— 山西大学大数据科学与产业研究院  钱教授'
    },
    {
        collegeName:"天津师范大学",
        collegeLogo:"static/college_logos/2022-09-29/天津师范大学-01.svg",
        schoolName:"数学科学学院",
        studentNum:"300+",
        years:3,
        usedTags:["数据分析","机器学习","深度学习"],
        outcome:['数据计算及应用专业要求学生：在知识素养上需拥有扎实的数学、统计学以及计算机科学基础；在技能素养上，要熟练掌握大数据分析方法、技术和手段；在应用能力上，拥有跨行业的实践应用能力（教育、金融、医疗等）。针对其多维的培养目标，该专业采用“数据实验楼”平台进行实训教学。',
'平台包含数据分析、数据可视化、机器学习、深度学习和人工智能相关的多个综合实训项目。基于《数据分析综合实训》课程开设在大四阶段的课程背景，选取了“个人信用风险评估项目”、“植物健康枯萎图像识别项目”、“Python数据分析项目”3个项目，在学生毕业前着重强化学生的实践能力，从而更好地助力学生就业。目前共计50余名学生参与课程并使用数据实验楼。'],
        usetProjects:["个人信用风险评估项目","植物健康枯萎图像识别项目","Python数据分析项目"],
        reviews:'"数据实验楼所提供的项目资源科学真实且贴合教学实际需求。在数据计算及应用专业的综合实训中，3个项目让学生能够将理论知识与实际操作紧密结合，极大地提升了实践能力和对专业知识的深入理解。" —— 天津师范大学 陈教授'
    },

]

export interface Props {}
export const Colleges: React.FC<Props> = (props) => {

    const [collegeList, setCollegeList] = useState([] as any);
    const queryContent = useRef('') //记录搜索串
    const page = useRef(1) //记录当前的页数
    const pageSize = useRef(32) //记录当前每页展示数量
    const [collegeSum, setCollegeSum]  = useState(0)


    useEffect(()=>{
        queryCollegeList()
    },[])



    const onQueryContentChange = (event: any) => {
        queryContent.current = event.target.value
    }


//页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryCollegeList()
  }


    //点击了搜索按钮
    const onSearchBtn = () => {
        page.current = 1
        queryCollegeList()
    }

    const queryCollegeList = ()=> {
        sendHttpPostRequest(
          'college/api/query_college_list',
          {
            query: queryContent.current,
            page:page.current,
            pagesize:  pageSize.current
          },
          (response: any) => {
            if (response.code == 0) {
                setCollegeList(response?.data?.list)
                setCollegeSum(response?.data?.page_info?.total_count)
            } 
          }
        )
    }


    return (
        <Layout>
            <div>

                <div className={css.staticsWrapper}>
                    <div  className={css.staticInnerWrapper} >
                        <div className={css.sectionTitle}>合作高校网络</div>
                        <div className={css.sectionDesp}>目前已有超过500所高校选择数据实验楼作为实践教学平台， 覆盖全国30个省市自治区，助力培养高素质AI人才。</div>
                        
                        <Row gutter={[24,24]}>
                            <Col xs={12} md={6}>
                                <div className={css.staticsBox}>
                                    <div className={css.staticsNumber}>500+</div>
                                    <div className={css.staticsKey}>合作高校</div>
                                </div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className={css.staticsBox}>
                                    <div className={css.staticsNumber}>30+</div>
                                    <div className={css.staticsKey}>覆盖省市</div>
                                </div>
                            </Col>

                            <Col xs={12} md={6}>
                                <div className={css.staticsBox}>
                                    <div className={css.staticsNumber}>550+</div>
                                    <div className={css.staticsKey}>开设课程</div>
                                </div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className={css.staticsBox}>
                                    <div className={css.staticsNumber}>50k+</div>
                                    <div className={css.staticsKey}>受益师生</div>
                                </div>
                            </Col>
                        </Row>


                    </div>
                    
                </div>

                <div className={css.keyCaseWrapper}>
                    <div  className={css.keyCaseInnerWrapper} >
                        <div className={css.sectionTitle}>重点合作案例</div>
                        <div className={css.sectionDesp}>探索数据实验楼如何助力各高校提升AI实践教学质量， 以下是部分重点合作高校的使用案例。</div>


                        
                        {cases?.map((onecase, index)=>(
                            <Row key={index} className={css.caseCard} >
                                <Col xs={24} md={7} className={css.leftDiv} >
                                    <div>
                                        <div className={css.caseLogoWrapper}>
                                            <img           
                                                style={{ width: 140, height: 30 }}
                                                src={onecase?.collegeLogo?.startsWith('http')? onecase?.collegeLogo: BACKEND_API_URL + onecase?.collegeLogo}>
                                            </img>  
                                        </div>
                                        <div className={css.caseCollegeName} >
                                            {onecase?.collegeName}
                                        </div>
                                        <div className={css.caseSchoolName} >
                                            {onecase?.schoolName}
                                        </div>

                                        <div className={css.caseTagsWrapper}>
                                            {onecase?.usedTags?.map((tag, index)=>(<span  key={index} className={css.caseTag} >{tag}</span>))}
                                        </div>

                                        <div className={css.caseStuNum} > <TeamOutlined />  {onecase?.studentNum} {" "} 学生使用 </div>

                                        <div className={css.caseYears} > <CalendarOutlined /> 合作{" "}{onecase?.years} {" "} 年 </div>
                                    </div>
                                </Col>

                                <Col xs={24} md={17} className={css.rightDiv}>
                                    <div>
                                        <div className={css.caseRightMainTitle}>项目应用与教学成果</div>
                                        <div>
                                            {
                                                onecase?.outcome?.map((oc,index)=>(
                                                    <div className={css.caseOC} key={index}>{oc}</div>
                                                ))
                                            }
                                        </div>
                                        <div className={css.caseRightSecontTitle}>主要使用项目</div>
                                        <div style={{marginBottom:24}}>
                                            <Row gutter={[12,12]} justify={'space-between'}>
                                                {
                                                    onecase?.usetProjects?.map((pj,index)=>(
                                                        <Col span={12} key={index}>
                                                            <div className={css.caseProject}>
                                                                 <Icon component={checkIcon} style={{marginRight:8}} />  {pj}
                                                            </div>
                                                        </Col>
                                                    ))
                                                }
                                            </Row>

                                        </div> 

                                        <div className={css.caseReview}>
                                            {onecase?.reviews}
                                        </div>                           
                                    </div>

                                </Col>

                            </Row>
                        ))}
                       
                    </div>
                    
                </div>



                <div className={css.collegeListWrapper}>
                    <div  className={css.collegeListInnerWrapper}  >
                        <div className={css.sectionTitle}>合作高校名单</div>
                        <div className={css.sectionDesp}>双一流高校、应用型本科高校、职业类院校、部分高中和初中学校采用数据实验楼开展项目制AI实践教学。</div>
                        <div style={{marginBottom:32}}>                         
                            <Input                   
                            onPressEnter={onSearchBtn}
                            onChange={onQueryContentChange} 
                            size="large" 
                            placeholder="请输入高校名称" 
                            prefix={<SearchOutlined />} 
                            style={{padding:'12px 16px 12px 16px', borderRadius:8}}
                        /></div>

                        <Row gutter={[32,32]} justify={'space-between'}>
                        { collegeList?.map((college, index)=>(
                            <Col xs={12} sm={8} md={6} key={college.id}>
                                <div className={css.collegeCard}>

                                    <span className={css.collegeProvince} > {college?.province} </span>

                                    <div className={css.collegeLogoWrapper}>
                                        <img           
                                            style={{ width: 100, height: 25 }}
                                                src={
                                                    college?.logo_url?.startsWith('http')
                                                      ? college?.logo_url
                                                      : BACKEND_API_URL + college?.logo_url
                                                  }></img>
                                        
                                    </div>

                                    <div className={css.collegeName} > {college?.name} </div>
                                </div>
                            </Col>
                        ))}
                        </Row>

                        <ConfigProvider locale={zhCN}>
                            <div className={css.pagination}>
                            <Pagination
                                defaultCurrent={1}
                                total={collegeSum}
                                current={page.current}
                                defaultPageSize={32}
                                hideOnSinglePage={true}
                                showSizeChanger={false}
                                onChange={onPageChange}
                            />
                            </div>
                        </ConfigProvider>

                    </div>
                </div>

            </div>

            <PageFooter />
        </Layout>
    )
}

export default Colleges

